import { Component, OnInit } from '@angular/core';
import { SharedModule } from '@Shared/shared.module';
import { FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { BaseInterviewFormFieldComponent, BaseFormFieldServices } from '../base-interview-form-field/base-interview-form-field.component';
import { FieldDetailsComponent } from '@Components/field-details/field-details.component';
import {MaskitoDirective} from '@maskito/angular';
import {MaskitoOptions} from '@maskito/core';

@Component({
    selector: 'ssn-answer',
    templateUrl: './ssn-answer.component.html',
    styleUrls: ['./ssn-answer.component.scss'],
    imports: [SharedModule, FieldDetailsComponent, MaskitoDirective]
})
export class SSNAnswerComponent extends BaseInterviewFormFieldComponent implements OnInit {
     maskitoOptions: MaskitoOptions = {
        mask:[/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
    };

    constructor(public services: BaseFormFieldServices) {

        super(services);
    }

    ngOnInit() {
        super.initialize({
            inputType: 'text',
            additionalValidators: [
                Validators.pattern(/^\d{3}-?\d{2}-?\d{4}$/)
            ]
        });
    }
}
